// `ref_src` values: which surface handed a visitor the referral link. Rides alongside `ref`
// on every share URL and is stored on the referral row at signup, so "did a forwarded email
// drive this?" is answerable — `referral.source` only ever says 'link'.
//
// These are the values this app emits, not a closed set: the backend stores whatever ref_src
// arrives (sanitised, not allowlisted), so a Customer.io template can add its own without a
// deploy. Kept in step with the LINK_SOURCE_* constants in
// diffit-api/app/utils/referral_links.py.

export const LINK_SOURCE = {
  COPY_LINK_PACKET_MODAL: 'copy_link_packet_modal',
  COPY_LINK_COLLEAGUES: 'copy_link_colleagues',
  COPY_LINK_TEMPLATE: 'copy_link_template',
  COPY_LINK_ORG_INVITE: 'copy_link_org_invite',
  COPY_LINK_EXPORT_MENU: 'copy_link_export_menu',
  COPY_LINK_SHARE_DIALOG: 'copy_link_share_dialog',
  COPY_LINK_REDEEM: 'copy_link_redeem',
  COPY_LINK_ONBOARDING: 'copy_link_onboarding',
  SOCIAL_EMAIL: 'social_email',
  SOCIAL_TWITTER: 'social_twitter',
  SOCIAL_FACEBOOK: 'social_facebook',
  SOCIAL_PINTEREST: 'social_pinterest',
  PROMO_BANNER_MATH: 'promo_banner_math',
};

// `invite_source` values: which surface a POST /referral/invites batch was sent from. Not a
// `ref_src` on a link the client builds — the backend composes it onto the invite email's
// `email_referral_invite` source (with_surface in diffit-api/app/utils/referral_links.py), so a
// signup off an emailed invite is attributable to the screen that asked for it. Several surfaces
// invite against one campaign, so `program_key` can't answer that.
//
// Kept in step with the INVITE_SOURCE_* constants in diffit-api/app/utils/referral_links.py.
export const INVITE_SOURCE = {
  ONBOARDING_WIZARD: 'onboarding_wizard',
  REFERRAL_PAGE: 'referral_page',
  // Covers the math promo banner as well as the promo ad: both are in-resource, and they invite
  // against different campaigns, so the program segment separates them.
  IN_RESOURCE_AD: 'in_resource_ad',
  // One value per ad SLOT, not one per card: the two cards in each of these invite against
  // different campaigns, so the program segment of the composed `ref_src` already separates them.
  SIDEBAR_AD: 'sidebar_ad',
  EXPORT_AD: 'export_ad',
};

/**
 * The invite source for a premium-offer paygate: `paygate_` plus the gate's own location.
 *
 * Per-gate rather than one value for the whole feature, so a signup off a forwarded invite
 * names the gate that asked. Locations are written for people ("My Resources Gate"), so they
 * are slugged to the separator-free charset the backend stores — matching `_clean` in
 * diffit-api/app/utils/referral_links.py rather than relying on it.
 */
export const paygateInviteSource = (location) => {
  const slug = String(location || '')
    .toLowerCase()
    .replace(/[^a-z0-9_-]+/g, '_')
    .replace(/^_+|_+$/g, '');
  return slug ? `paygate_${slug}` : null;
};
